import { ExemplarType } from './../../types/index';
import { AxiosPrivate } from '../../utils';

interface IData {
  data: Array<ExemplarType>;
}

class CollectionsApi {
  private static instance: CollectionsApi;

  public static getInstance(): CollectionsApi {
    if (!CollectionsApi.instance) {
      CollectionsApi.instance = new CollectionsApi();
    }

    return CollectionsApi.instance;
  }

  getAll = (stage: string) => {
    return AxiosPrivate.get<IData>(`/v1/collections/?stage=${stage}`);
  };
}

export const collectionsApi = CollectionsApi.getInstance();
